import { Button, Stack} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';

interface TableToolbarProps {
  onGenerateMagicLink: () => void;
  isGenerateMagicLinkDisabled?: boolean;
}

export default function TableToolbar({
  onGenerateMagicLink,
  isGenerateMagicLinkDisabled = false,
}: TableToolbarProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 1.5 }}
    >
      <Button
        id="generate-magic-link-btn"
        variant="contained"
        size="small"
        startIcon={<LinkIcon sx={{ fontSize: '15px !important' }} />}
        onClick={onGenerateMagicLink}
        disabled={isGenerateMagicLinkDisabled}
        sx={{ fontWeight: 700, px: 2 }}
      >
        Generate Magic Link
      </Button>
    </Stack>
  );
}
